import { useCart } from "@/composables/marketplace/cart";
import { assertSameCurrency } from "@/services/currencies";
import { type SingleSellerCart, assertAllItemsInSingleSellerCartOfSameCurrency, assertCartExists, hasSelectedPaymentMethod, hasSelectedShippingMethod } from "@/services/marketplace/cart";
import { createNumericPrice } from "@/services/prices";

export function useSingleSellerCart(cart: SingleSellerCart) {
  const totalItemsPrice = computed(() => {
    assertAllItemsInSingleSellerCartOfSameCurrency(cart);
    return cart.priceItemsTotal;
  });

  const totalQuantity = computed((): number => {
    let total = 0;
    cart.items.map(({ quantity }) => (total += quantity));
    return total;
  });

  const commissionPrice = computed(() => {
    const { cart: fullCart } = useCart();
    assertCartExists(fullCart.value);
    const totalAmount = cart.priceCommission.price + fullCart.value?.priceCommissionFixedPart.price;
    const currencyId = cart.priceCommission.currencyId;
    // @todo check currencies are same
    return createNumericPrice(totalAmount, currencyId);
  });

  /** Items + shipping + payment + commission */
  const totalPrice = computed(() => {
    const currencyId = totalItemsPrice.value?.currencyId;
    if (currencyId === undefined) {
      throw new Error("DEV: Should not happen. CurrencyId was not set.");
    }

    const { cart: fullCart } = useCart();
    assertCartExists(fullCart.value);
    let total = totalItemsPrice.value?.price ?? 0;

    if (hasSelectedPaymentMethod(fullCart.value)) {
      assertSameCurrency(totalItemsPrice.value, fullCart.value.selectedPaymentMethod.price);
      total += fullCart.value.selectedPaymentMethod.price.price;
    }

    if (hasSelectedShippingMethod(fullCart.value)) {
      assertSameCurrency(totalItemsPrice.value, fullCart.value.selectedShippingMethod.price);
      total += fullCart.value.selectedShippingMethod.price.price;
    }

    const priceCommission = commissionPrice.value;
    assertSameCurrency(totalItemsPrice.value, priceCommission);
    total += priceCommission.price;

    return createNumericPrice(total, currencyId);
  });

  return {
    totalQuantity,
    totalItemsPrice,
    totalPrice,
    commissionPrice,
  };
}
